import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Star, ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface Testimonial {
  title: string;
  quote?: string;
  name: string;
}
export function TestimoniosSistema() {
  const [showAll, setShowAll] = useState(false);
  const initialTestimonials: Testimonial[] = [{
    title: 'Por fin entendí cómo empezar.',
    quote: 'Después de meses viendo videos gratuitos, aquí encontré un sistema claro y organizado.',
    name: 'Javier M. 🇺🇸 Charlotte, NC'
  }, {
    title: 'El Sistema Completo fue la mejor decisión.',
    quote: 'Pensaba comprar solamente FBA, pero terminé aprendiendo ambos modelos y valió totalmente la pena.',
    name: 'Carlos R. 🇺🇸 Miami, FL'
  }, {
    title: 'Mucho mejor de lo que esperaba.',
    quote: 'Todo está explicado paso a paso y sin complicaciones.',
    name: 'Andrea G. 🇨🇴 Bogotá'
  }, {
    title: 'Ideal para principiantes.',
    quote: 'Nunca había vendido en Amazon y pude seguir todas las clases sin perderme.',
    name: 'Miguel A. 🇲🇽 Ciudad de México'
  }, {
    title: 'Una inversión que realmente vale la pena.',
    quote: 'Solo los bonos ya tienen muchísimo valor.',
    name: 'Daniela P. 🇺🇸 Houston, TX'
  }, {
    title: 'Lo volvería a comprar.',
    quote: 'Si hubiera encontrado este sistema antes, habría evitado muchos errores.',
    name: 'Roberto L. 🇪🇸 Madrid'
  }];
  const additionalTestimonials: Testimonial[] = [{
    title: 'Me dio la confianza que necesitaba para comenzar.',
    name: 'Luis C. 🇺🇸 Orlando, FL'
  }, {
    title: 'Todo está muy bien organizado.',
    quote: 'Nunca sentí que me faltara información.',
    name: 'María S. 🇨🇱 Santiago'
  }, {
    title: 'Recuperé la inversión rápidamente gracias a todo lo que aprendí.',
    name: 'Andrés T. 🇺🇸 Dallas, TX'
  }, {
    title: 'Las explicaciones son sencillas y fáciles de seguir.',
    name: 'Paola R. 🇵🇪 Lima'
  }, {
    title: 'Los bonos premium superaron mis expectativas.',
    name: 'José M. 🇦🇷 Buenos Aires'
  }, {
    title: 'Recomiendo el Sistema Completo a cualquiera que quiera empezar correctamente.',
    name: 'Carolina V. 🇺🇸 New York, NY'
  }];
  const renderCard = (t: Testimonial, key: React.Key) => <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.1)] border border-brand-text/5 h-full flex flex-col" data-id="element-901">
      <div className="flex gap-1 mb-6" data-id="element-902">
        {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-903" />)}
      </div>
      <h3 className="text-xl font-bold text-brand-green mb-3" data-id="element-904">"{t.title}"</h3>
      {t.quote && <p className="text-brand-text/80 text-lg leading-relaxed mb-8 flex-grow" data-id="element-905">
          {t.quote}
        </p>}
      <p className="text-brand-text/50 font-medium mt-auto" data-id="element-906">— {t.name}</p>
    </div>;
  return <section className="bg-brand-beige/30 py-20 md:py-32 px-4 sm:px-6" data-id="element-907">
      <div className="max-w-6xl mx-auto" data-id="element-908">
        <FadeIn data-id="element-909">
          <div className="text-center mb-16" data-id="element-910">
            <span className="inline-block text-2xl mb-4" data-id="element-911">⭐</span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-brand-green mb-4 tracking-tight" data-id="element-912">
              Miles de personas ya comenzaron su camino hacia vender en Amazon.
            </h2>
            <p className="text-base sm:text-lg text-brand-text/65 max-w-2xl mx-auto" data-id="element-913">
              Descubre por qué tantos estudiantes decidieron comenzar con
              nuestros sistemas y cómo esta formación les dio la confianza para
              dar el primer paso.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-914">
          {initialTestimonials.map((t, i) => <FadeIn key={i} delay={0.1 * i} data-id="element-915">
              {renderCard(t, i)}
            </FadeIn>)}
        </div>

        <AnimatePresence initial={false} data-id="element-916">
          {showAll && <motion.div key="more-testimonials" initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.45,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-917">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 mt-8 lg:mt-12" data-id="element-918">
                {additionalTestimonials.map((t, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4,
              delay: 0.05 * i
            }} data-id="element-919">
                    {renderCard(t, `more-${i}`)}
                  </motion.div>)}
              </div>
            </motion.div>}
        </AnimatePresence>

        <div className="text-center mt-14" data-id="element-920">
          <Button onClick={() => setShowAll(prev => !prev)} className="bg-brand-green hover:bg-brand-green/90 !text-white font-bold px-10 py-4 inline-flex items-center gap-2 ring-1 ring-brand-gold/30" data-id="element-921">
            <span data-id="element-922">{showAll ? 'VER MENOS OPINIONES' : 'VER MÁS OPINIONES'}</span>
            {showAll ? <ChevronUp className="w-4 h-4" data-id="element-923" /> : <ChevronDown className="w-4 h-4" data-id="element-924" />}
          </Button>
        </div>
      </div>
    </section>;
}